import { Module } from 'wrapper6';
import $ from 'jquery';
import { debounce } from '../utils/_debounce';

export default class TestimonialSlider extends Module {
	ready() {

        const WRAPPERS = document.querySelectorAll('.mtt-testimonial-slider');

        if (WRAPPERS) {
            for (let i = 0; i < WRAPPERS.length; i++) {
                
                const WRAPPER = WRAPPERS[i];
                const SLIDER_ELEMENT = WRAPPER.querySelector('.swiper-container');
                const PAGINATION_ELEMENT = WRAPPER.querySelector('.mtt-testimonial-slider__pagination');
                const SLIDES = WRAPPER.querySelectorAll('.mtt-testimonial-slider__slide');

                // init slider
                const SLIDER = new Swiper(SLIDER_ELEMENT, {
                    speed: 600,
                    slidesPerView: 1.25,
                    loop: false,
                    centeredSlides: true,
                    observer: true,
                    observeParents: true,
                    spaceBetween: 16,
                    pagination: {
                        el: PAGINATION_ELEMENT,
                        type: 'bullets',
                        clickable: true
                    },
                    breakpoints: {
                        350: {
                            centeredSlides: true,
                            slidesPerView: 1.4,
                            spaceBetween: 16,
                        },
                        450: {
                            centeredSlides: true,
                            slidesPerView: 1.6,
                            spaceBetween: 16,
                        },
                        650: {
                            centeredSlides: false,
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        700: {
                            centeredSlides: false,
                            slidesPerView: 2,
                            spaceBetween: 32
                        },
                        960: {
                            centeredSlides: false,
                            slidesPerView: 3,
                            spaceBetween: 32
                        }
                    }
                });

                // is slideable?
                this.isSlidable(SLIDER, SLIDES.length, PAGINATION_ELEMENT);
                window.addEventListener('resize', debounce(() => this.isSlidable(SLIDER, SLIDES.length, PAGINATION_ELEMENT), 300));
                
            }
        }
    }

    /**
     * Check if slider is slideable
     * @param {Object} SLIDER 
     * @param {Integer} COUNT 
     * @param {Object} PAGINATION 
     */
    isSlidable(SLIDER, COUNT, PAGINATION) {

        if (SLIDER) {

            if (COUNT <= SLIDER.params.slidesPerView) {
                SLIDER.params.grabCursor = false;
                SLIDER.params.touchRatio = 0;
                PAGINATION.style.display = 'none';
            } else {
                SLIDER.params.grabCursor = true;
                SLIDER.params.touchRatio = 1;
                PAGINATION.style.display = 'block';
            }

            SLIDER.update();
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_testimonial-slider.js